import React, { Fragment } from 'react'

import { useNavigate } from 'react-router-dom';

import VisaForm from '../../forms/VisaForm';

import { StudentImmigrationTab } from '../../../../interfaces/student';
import { IVisaDetail } from '../../../../interfaces/services';

interface IVisaProps {
    studentId: number;
    setCurrentTab: (tab: StudentImmigrationTab) => void;
    visas: IVisaDetail[];
}

const Visa = (props: IVisaProps) => {
    const navigate = useNavigate();

    const { setCurrentTab, visas, studentId } = props;

    const onGoBack = () => {
        setCurrentTab('Permit');
    };

    const onGoNext = () => {
        navigate(`/students/${studentId}/change-log`);
    };

    return (
        <div className='immersion__details_form'>
            <div className="immersion__details_form_inputs__container">
                {visas.map((visa, index) => (
                    <Fragment key={index}>
                        <VisaForm
                            studentId={studentId}
                            data={visa}
                        />

                        {index < visas.length - 1 && (
                            <Fragment>
                                <div className="immersion__details_form_inputs__container__divider" />
                                <br />
                                <br />
                            </Fragment>
                        )}

                    </Fragment>
                ))}
            </div>

            <div className="immersion__details_form_actions">
                <button
                    className={`immersion__btn immersion__btn__secondary`}
                    onClick={onGoBack}
                >
                    Go back
                </button>

                <button
                    className={`immersion__btn immersion__btn__primary`}
                    onClick={onGoNext}
                >
                    Next
                </button>
            </div>
        </div>
    )
}

export default Visa;